
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "56px",
    "height": "40px",
    "viewBox": "0 0 56 40",
    "enable-background": "new 0 0 56 40",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#999999",
        "width": "56",
        "height": "40"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M4,25.977h6.953v-4.5H5.234v-1.188h5.719v-3.563H4.625v-1.188h13.938v1.188h-6.266v3.563h5.719v1.188\r\n\t\t\th-5.719v4.5h6.953v1.156H4V25.977z M10.359,13.227l1.156-0.594c0.635,0.948,1.094,1.683,1.375,2.203l-1.234,0.656\r\n\t\t\tC11.094,14.45,10.661,13.695,10.359,13.227z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M20,21.758h2.375c0.229-0.396,0.453-0.802,0.672-1.219l1.125,0.359c-0.167,0.292-0.333,0.578-0.5,0.859\r\n\t\t\tH27.5v1.016c-0.396,1.021-0.995,1.917-1.797,2.688c0.573,0.271,1.156,0.542,1.75,0.813l-0.688,1.078\r\n\t\t\tc-0.646-0.364-1.318-0.729-2.016-1.094c-1.177,0.844-2.662,1.511-4.453,2c-0.167-0.333-0.344-0.698-0.531-1.094\r\n\t\t\tc1.521-0.344,2.807-0.839,3.859-1.484c-0.896-0.458-1.833-0.927-2.813-1.406c0.333-0.479,0.656-0.974,0.969-1.484H20V21.758z\r\n\t\t\t M20.172,16.383h3.594v-3.5h1.156v3.5h3v1.031h-3v0.953l0.469-0.531c0.969,0.708,1.781,1.333,2.438,1.875l-0.75,0.875\r\n\t\t\tc-0.573-0.542-1.292-1.151-2.156-1.828v1.781h-1.156v-2.188c-0.948,0.989-2.052,1.859-3.313,2.609\r\n\t\t\tc-0.198-0.302-0.422-0.62-0.672-0.953c1.313-0.708,2.516-1.573,3.609-2.594h-3.219V16.383z M20.578,13.961l0.891-0.609\r\n\t\t\tc0.469,0.573,0.953,1.188,1.453,1.844l-0.969,0.688C21.495,15.206,21.036,14.565,20.578,13.961z M22.344,23.914\r\n\t\t\tc0.739,0.333,1.5,0.683,2.281,1.047c0.719-0.614,1.281-1.339,1.688-2.172h-3.25C22.823,23.175,22.583,23.55,22.344,23.914z\r\n\t\t\t M27.219,13.273l0.969,0.641c-0.573,0.75-1.146,1.442-1.719,2.078c-0.24-0.208-0.521-0.427-0.844-0.656\r\n\t\t\tC26.167,14.7,26.698,14.013,27.219,13.273z M30.063,12.742l1.25,0.188c-0.219,1.011-0.474,1.953-0.766,2.828h4.781v1.063h-0.984\r\n\t\t\tc-0.261,3.063-0.927,5.495-2,7.297c0.844,1.146,1.917,2.083,3.219,2.813c-0.333,0.458-0.615,0.87-0.844,1.234\r\n\t\t\tc-1.271-0.823-2.328-1.802-3.172-2.938c-0.958,1.188-2.099,2.219-3.422,3.094c-0.229-0.302-0.526-0.63-0.891-0.984\r\n\t\t\tc1.458-0.958,2.641-2.047,3.547-3.266c-0.844-1.458-1.401-3.141-1.672-5.047c-0.219,0.386-0.448,0.745-0.688,1.078\r\n\t\t\tc-0.208-0.302-0.469-0.636-0.781-1C28.849,17.362,29.656,15.242,30.063,12.742z M33.094,16.82h-2.922\r\n\t\t\tc-0.052,0.136-0.109,0.266-0.172,0.391c0.188,2.208,0.708,4.099,1.563,5.672C32.396,21.362,32.906,19.341,33.094,16.82z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M35.875,21.086c0.739-0.203,1.458-0.409,2.156-0.617v-3.57h-1.969v-1.125h1.969v-2.984h1.156v2.984h1.703\r\n\t\t\tv1.125h-1.703v3.211c0.495-0.156,0.979-0.315,1.453-0.477c0.01,0.469,0.042,0.875,0.094,1.219\r\n\t\t\tc-0.537,0.172-1.052,0.341-1.547,0.508v4.727c0,1.177-0.516,1.776-1.547,1.797c-0.323,0.011-0.802,0.005-1.438-0.016\r\n\t\t\tc-0.042-0.417-0.104-0.849-0.188-1.297c0.573,0.063,1.01,0.094,1.313,0.094c0.469,0,0.703-0.266,0.703-0.797v-4.125\r\n\t\t\tc-0.714,0.239-1.38,0.469-2,0.688L35.875,21.086z M42.875,22.664h3.219V20.68h-3.641c-0.115,3.203-0.854,5.677-2.219,7.422\r\n\t\t\tc-0.25-0.323-0.531-0.651-0.844-0.984c1.302-1.604,1.953-4.067,1.953-7.391v-6.094h9.219v4.531h-1.125V17.68h-6.969v1.938h3.625\r\n\t\t\tv-1.641h1.125v1.641h4.125v1.063h-4.125v1.984h3.25v5.281h-1.125v-0.906H44v0.906h-1.125V22.664z M49.438,14.664h-6.969v1.984\r\n\t\t\th6.969V14.664z M49.344,23.695H44v2.328h5.344V23.695z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  